import { render } from "./AnswerDetails.vue?vue&type=template&id=c989cb96&scoped=true"
import script from "./AnswerDetails.vue?vue&type=script&lang=js"
export * from "./AnswerDetails.vue?vue&type=script&lang=js"

import "./AnswerDetails.vue?vue&type=style&index=0&id=c989cb96&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/悦库.Site-ScoreQuery-Release/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c989cb96"]])

export default __exports__